import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import axios from 'axios';
import ReactDatePicker from 'react-datepicker';
import moment from 'moment';
import { API_URL } from '../../../../../constants';
const AcademicDetails = (props) => {
    const initialRoleFormData = {
        unviersity: [],
        institute: [],
        degree: [],
        degree_info_disable:[],
        degree_info: [],
        passing_year: []
    };
    const [formData, setFormData] = useState(initialRoleFormData);
    const [options, setOptions] = useState([]);
    const [degreeInfoDisable,setDegreeInfo] = useState([]);

    const [rows, setRows] = useState([['', '', '', '', '', '']]);
    const addRow = () => {
        setRows([...rows, ['', '', '', '', '', '']]);
    };

    const deleteRow = (index) => {
        formData.splice(index, 1);
    };

    const handleChange = (e, rowIndex, column_name) => {
   
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState
        }));
        formData[column_name][rowIndex] = value;
        handleUpdatingValueAfterChanged(formData);
        if(column_name=='degree'){
            if(e.target.selectedOptions[0].text=='Other'){
                formData['degree_info_disable'][rowIndex] = false;
            }else{
                formData['degree_info_disable'][rowIndex] = true;
            }
        }
    };
    const handleDateChanged = (date, rowIndex, column_name) => {
        setFormData(prevState => ({
            ...prevState
        }));
        formData[column_name][rowIndex] = moment(date).format('YYYY');
        handleUpdatingValueAfterChanged(formData);
    };
    const handleUpdatingValueAfterChanged = (data) => {
        props.onAcademicDataChange(data);
    }
    const fetchOptions = async () => {
        try {
            const response = await axios.get(API_URL + 'fetch-degree');
            setOptions(response.data[0].Masters);
        } catch (error) {
            console.error("Error fetching code options:", error);
        }
    };
    useEffect(() => {
        fetchOptions();
    }, []);
    return (
        <div>
            <div className="table-responsive poc-head rounded mt-2">
                <table id="poctable_head" className="table table-bordered">
                    <thead className='text-center' >
                        <tr className="head">
                            <th>Sr</th>
                            <th>University</th>
                            <th>Institute</th>
                            <th>Degree</th>
                            <th>Degree Info</th>
                            <th>Passing Year</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, rowIndex) => (
                            <tr key={rowIndex} className={rowIndex % 2 === 0 ? 'alt' : ''}>
                                <td>{rowIndex + 1}</td>
                                <td><input class="form-control" name="university[]" placeholder="University" onChange={(e) => handleChange(e, rowIndex, 'unviersity')} value={formData['unviersity'][rowIndex]} />

                                </td>
                                <td><input class="form-control" name="institute[]" placeholder="Institite" onChange={(e) => handleChange(e, rowIndex, 'institute')} value={formData['institute'][rowIndex]} />

                                </td>
                                <td>
                                    <select class="form-control" name="degree[]"  value={formData['degree'][rowIndex]} onChange={(e) => handleChange(e, rowIndex, 'degree')} >
                                        <option key='' value="">
                                            Select
                                        </option>
                                        {options.length > 0
                                            ? options.map((code) => (
                                                <option key={code.value} value={code.value}>
                                                    {code.text}
                                                </option>
                                            ))
                                            : ''}
                                    </select>
                                </td>
                                <td>
                                    <input class="form-control" name="degree_info[]" disabled={formData['degree_info_disable'][rowIndex]?true:false} placeholder="" onChange={(e) => handleChange(e, rowIndex,'degree_info')} value={formData['degree_info'][rowIndex]}/>
                                </td>
                                <td>
                                    <ReactDatePicker maxDate={new Date()} showYearPicker name="year[]" className='form-control' placeholderText='Year' showIcon icon='fa fa-calendar' value={formData['passing_year'][rowIndex]} onChange={(date)=>handleDateChanged(date,rowIndex,'passing_year')} format='YYYY'/>
                                </td>
                                <td>
                                    <i className="fa fa-trash-o poc_delectbtn" onClick={() => deleteRow(rowIndex)}></i>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button type="button" onClick={addRow} className="custom-btn pull-right btn btn-sm btn-info"><i class="fa fa-plus"></i>&nbsp;Add</button>
        </div>


    )
}

export default AcademicDetails;